import LoginTemplate from 'components/templates/LoginTemplate';
import Form, { useForm } from 'components/molecules/Form';
import Field from 'components/molecules/Field';
import Button from 'components/atoms/Button';
import { useState } from 'react';
import Toast from 'components/molecules/Toast';
import authService from 'services/authService';
import { useNavigate } from 'react-router-dom';

export default function ForgotPassword() {
  const nevigate = useNavigate();
  const [form] = useForm();
  const [loading, setLoading] = useState('');

  const onSubmit = async values => {
    setLoading(true);

    await authService
      .forgotPassword(values)
      .then(res => {
        nevigate('/');
        Toast({
          type: 'success',
          message: res?.message ?? res ?? 'Something Went Wrong',
        });
      })
      .catch(reason => {
        Toast({
          type: 'error',
          message: reason?.message ?? 'Something Went Wrong',
        });
      });
    setLoading(false);
  };
  return (
    <LoginTemplate
      backButton
      title="Forgot Password?"
      subtitle="To reset your password, please enter the email address you used to create your account and we'll send you a link.">
      <Form form={form} onSubmit={onSubmit}>
        <Form.Item
          bgLight
          type="email"
          label="Email"
          name="email"
          placeholder="Email"
          prefix={<i className="material-icons-outlined">email</i>}
          rules={[
            { required: true, message: 'Please enter email address' },
            { email: true, message: 'Please enter a valid email' },
            { max: 40, message: 'Email should be at max 40 characters!' },
          ]}>
          <Field />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Submit
        </Button>
      </Form>
    </LoginTemplate>
  );
}
